<template>
<div class="chapter">
<div class="inner_page">
<h1 class="toc-title">Contents</h1>
<p class="toc-fm"><a href="#/005_Ack#fm-1">Acknowledgments</a></p>
<p class="toc-fm"><a href="#/006_Intro#fm-2"><em>Introduction: Defining Evangelicals in a Christian Bookstore</em></a></p>
<p class="toc-chap"><a href="#/007_Chapter01#ch-1"><em>1.<span class="pad">The Romance of Abundant Life</span></em><br/>Janette Oke’s <em>Love Comes Softly</em></a></p>
<p class="toc-chap"><span href="#/008_Chapter02#ch-2" title="Link target outside of Sample"><em>2.<span class="pad">Spiritual Warfare in Everyday America</span></em><br/>Frank Peretti’s <em>This Present Darkness</em></span></p>
<p class="toc-chap"><span href="#/009_Chapter03#ch-3" title="Link target outside of Sample"><em>3.<span class="pad">The Rapture Dilemma</span></em><br/>Tim LaHaye and Jerry Jenkins’s <em>Left Behind</em></span></p>
<p class="toc-chap"><span href="#/010_Chapter04#ch-4" title="Link target outside of Sample"><em>4.<span class="pad">Authenticity in Amish Bonnets</span></em><br/>Beverly Lewis’s <em>The Shunning</em></span></p>
<p class="toc-chap"><span href="#/011_Chapter05#ch-5" title="Link target outside of Sample"><em>5.<span class="pad">Amid Emerging Ambiguities</span></em><br/>William Paul Young’s <em>The Shack</em></span></p>
<p class="toc-bm"><span href="#/012_Conclusion#bm-1" title="Link target outside of Sample"><em>Conclusion: The Question That Remains</em></span></p>
<p class="toc-bm"><span href="#/013_Endnotes#bm-2" title="Link target outside of Sample">Notes</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004_Contents.vue?28d81e3a